import {contact} from './Endpoints'
import axios from 'axios'

export default {
    async onPostContactMessage(data, config){
        const response = await axios.post(`${contact.onPostContactMessage()}`, data, config);
        return response.data;
    }
}